"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./BlackFridayOtherFeatures.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-700":{"id":"e-700","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-701"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0124c552-875f-57d9-d80b-6ce43ac85bb1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0124c552-875f-57d9-d80b-6ce43ac85bb1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1732306037475},"e-702":{"id":"e-702","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-703"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0124c552-875f-57d9-d80b-6ce43ac85bb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0124c552-875f-57d9-d80b-6ce43ac85bb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1732306037475},"e-704":{"id":"e-704","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-705"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0124c552-875f-57d9-d80b-6ce43ac85bb6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0124c552-875f-57d9-d80b-6ce43ac85bb6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"LEFT","effectIn":true},"createdOn":1732306037475},"e-706":{"id":"e-706","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-707"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0124c552-875f-57d9-d80b-6ce43ac85bbf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0124c552-875f-57d9-d80b-6ce43ac85bbf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"LEFT","effectIn":true},"createdOn":1732306037475},"e-708":{"id":"e-708","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-709"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0124c552-875f-57d9-d80b-6ce43ac85bc8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0124c552-875f-57d9-d80b-6ce43ac85bc8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"LEFT","effectIn":true},"createdOn":1732306037475}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"slideInLeft":{"id":"slideInLeft","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":-100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function BlackFridayOtherFeatures({
  as: _Component = _Builtin.Section,
}) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "blackfriday_section-other-features")}
      tag="section"
      grid={{
        type: "section",
      }}
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-section-medium")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "blackfriday_container-other-features",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "blackfriday_other-features-heading",
                  "text-align-center"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "blackfriday_other-features-copy-wrap"
                  )}
                  tag="div"
                >
                  <_Builtin.Heading
                    className={_utils.cx(
                      _styles,
                      "blackfriday_other-features-section-heading-copy"
                    )}
                    data-w-id="0124c552-875f-57d9-d80b-6ce43ac85bb1"
                    tag="h3"
                  >
                    {"Take the stress out of renting"}
                  </_Builtin.Heading>
                  <_Builtin.Paragraph
                    className={_utils.cx(
                      _styles,
                      "text-color-secondary",
                      "halifax_features-heading-description-center"
                    )}
                    data-w-id="0124c552-875f-57d9-d80b-6ce43ac85bb3"
                  >
                    {
                      "Streamline your rental management from start to finish with liv.rent's all-in-one features."
                    }
                  </_Builtin.Paragraph>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "blackfriday_other-features-grid"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "blackfriday_other-features-card"
                  )}
                  data-w-id="0124c552-875f-57d9-d80b-6ce43ac85bb6"
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "icon-height-medium")}
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6643f1e7963a2178aa91f02d_icon-payments.svg"
                  />
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_other-features-copy"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_other-features-card-heading",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph>
                        {"Multi-Platform Advertising"}
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_other-features-card-description",
                        "text-size-small"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(
                          _styles,
                          "blackfriday_other-features-card-description"
                        )}
                      >
                        {
                          "Maximize your reach with automated sharing to popular platforms like Facebook."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "blackfriday_other-features-card"
                  )}
                  data-w-id="0124c552-875f-57d9-d80b-6ce43ac85bbf"
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "icon-height-medium")}
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6643f1e74274d725bde6bf5a_icon-syndication.svg"
                  />
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_other-features-copy"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_other-features-card-heading",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph>
                        {"Create Contracts"}
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_other-features-card-description",
                        "text-size-small"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(
                          _styles,
                          "blackfriday_other-features-card-description"
                        )}
                      >
                        {
                          "Quickly create legally-vetted contracts with pre-loaded lease agreement templates."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "blackfriday_other-features-card"
                  )}
                  data-w-id="0124c552-875f-57d9-d80b-6ce43ac85bc8"
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "icon-height-medium")}
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6643f1e7fa63a0ba2428b16f_icon-contracts.svg"
                  />
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_other-features-copy"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_other-features-card-heading",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph>
                        {"Automated Rental Payments"}
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_other-features-card-description",
                        "text-size-small"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(
                          _styles,
                          "blackfriday_other-features-card-description"
                        )}
                      >
                        {
                          "Set payment reminders and get paid on time, every time directly through liv.rent."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
